export default __webpack_public_path__ + "dbff3bdbfa5185f227e14fd330d5d241.png";